import { useRef, useState, useLayoutEffect, useEffect } from "react";

import { createHookContext } from "utils/createHookContext";

export const useTitleState = createHookContext(() => {
  const containerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const [showRenameForm, setShowRenameForm] = useState(false);
  const [containerTranslation, setContainerTranslation] = useState(0);
  const [mutatedValue, setMutatedValue] = useState("");

  useLayoutEffect(() => {
    const $container = containerRef.current;
    const $parent = $container?.parentElement;
    if (!$container || !$parent) return;

    const setTranslationAmount = () => {
      const elWidth = $container.offsetWidth;
      const parentMiddle = $parent.offsetWidth / 2;

      const initialX = $container.offsetLeft - $parent.offsetLeft;
      const elMiddle = initialX + elWidth / 2;
      const endX = parentMiddle - elMiddle;

      setContainerTranslation(endX);
    };

    setTranslationAmount();
    $container.addEventListener("resize", setTranslationAmount);
    return () => $container.removeEventListener("resize", setTranslationAmount);
    // recalculate on resize AND on value change
  }, [containerRef, mutatedValue]);

  useEffect(() => {
    const input = inputRef.current;
    if (!showRenameForm || !input) return;

    input.focus();
    input.setSelectionRange(0, input.value.length);
  }, [showRenameForm]);

  return {
    containerRef,
    inputRef,
    showRenameForm,
    setShowRenameForm,
    containerTranslation,
    mutatedValue: mutatedValue,
    setMutatedValue,
  };
});
